// import React from "react";
// import { Countrieslist } from "../../../../../Constants/CountriesAndCodes";
// import {
//   Autocomplete,
//   Box,
//   TextField,
//   createFilterOptions,
// } from "@mui/material";
// import "./DialCodeSelector.css";
// import { useSelector } from "react-redux";

// function DialCodeSelector({ Theme, IconComponent, value, onChange , label , size , width}) {
//   // Custom filter function to prioritize exact matches and filter out irrelevant results
//   const filterOptions = createFilterOptions({
//     stringify: (option) => `${option.phone} ${option.name}`,
//     trim: true,
//     limit: 100,
//   });

//   return (
//     <Autocomplete
//   size={size}
//   id="country-select-demo"
//   sx={{
//     width, // Controls the width of the input field
//     "& .MuiOutlinedInput-root": {
//       borderColor: Theme == "averta" ? "#C2A07C" : "inherit",
//       "&:hover .MuiOutlinedInput-notchedOutline": {
//         borderColor: Theme === "averta" ? "#C2A07C" : "#0057B7",
//       },
//       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//         borderColor: Theme == "averta" ? "#C2A07C" : "#0057B7",
//       },
//     },
//   }}
//   options={Countrieslist}
//   autoHighlight
//   disableClearable
//   value={value}
//   onChange={(event, newValue) => onChange(newValue)}
//   popupIcon={IconComponent}
//   filterOptions={filterOptions}
//   getOptionLabel={(option) => `${option.phone}`}
//   componentsProps={{
//     paper: { sx: { width: "100%" } }, // Ensures dropdown matches input width
//   }}
//   renderOption={(props, option) => {
//     const { key, ...optionProps } = props;
//     return (
//       <Box
//         key={key}
//         component="li"
//         sx={{
//           fontSize: "16px",
//           fontFamily: `var(--font-family-${
//             Theme === "proxima"
//               ? `${Theme}_nova-regular`
//               : `${Theme}-regular`
//           })`,
//           fontStyle: "normal",
//           fontWeight: "400",
//           "& > img": { mr: 2, flexShrink: 0 },
//         }}
//         {...optionProps}
//       >
//         <img
//           loading="lazy"
//           width="20"
//           srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
//           src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
//           alt=""
//         />
//         {`${option.phone}`}
//       </Box>
//     );
//   }}
//   renderInput={(params) => (
//     <TextField
//       sx={{
//         fontSize: "16px",
//         fontFamily: `var(--font-family-${
//           Theme === "proxima" ? `${Theme}_nova-regular` : `${Theme}-regular`
//         })`,
//         fontStyle: "normal",
//         fontWeight: "400",
//       }}
//       {...params}
//       label={label}
//       fullWidth // Ensures the input takes full width
//       inputProps={{
//         ...params.inputProps,
//         autoComplete: "new-password",
//       }}
//     />
//   )}
// />

//   );
// }

// export default DialCodeSelector;

import React from "react";
import { Countrieslist } from "../../../../../Constants/CountriesAndCodes";
import {
  Autocomplete,
  Box,
  TextField,
  createFilterOptions,
} from "@mui/material";
import "./DialCodeSelector.css";

function DialCodeSelector({ Theme, IconComponent, value, onChange, label, size, width }) {
  // Custom filter function to prioritize exact matches and filter out irrelevant results
  const filterOptions = createFilterOptions({
    stringify: (option) => `${option.phone} ${option.name}`,
    trim: true,
    limit: 100,
  });

  return (
    <Autocomplete
      size={size}
      id="country-select-demo"
      sx={{
        width, // Controls the width of the input field
        "& .MuiOutlinedInput-root": {
          borderColor: Theme === "averta" ? "#C2A07C" : "inherit",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: Theme === "averta" ? "#C2A07C" : "#0057B7",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: Theme === "averta" ? "#C2A07C" : "#0057B7",
          },
        },
      }}
      options={Countrieslist}
      autoHighlight
      disableClearable
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      popupIcon={IconComponent}
      filterOptions={filterOptions}
      getOptionLabel={(option) => `${option.phone}`}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            key={key}
            component="li"
            sx={{
              fontSize: "16px",
              fontFamily: `var(--font-family-${
                Theme === "proxima" ? `${Theme}_nova-regular` : `${Theme}-regular`
              })`,
              fontStyle: "normal",
              fontWeight: "400",
              "& > img": { mr: 2, flexShrink: 0 },
            }}
            {...optionProps}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt={option.name}
            />
            {`${option.phone}`}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          fullWidth
          sx={{
            fontSize: "16px",
            fontFamily: `var(--font-family-${
              Theme === "proxima" ? `${Theme}_nova-regular` : `${Theme}-regular`
            })`,
            fontStyle: "normal",
            fontWeight: "400",
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: value ? (
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${value.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${value.code.toLowerCase()}.png`}
                alt={value.name}
                style={{ marginRight: 8 }}
              />
            ) : null,
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password",
          }}
        />
      )}
    />
  );
}

export default DialCodeSelector;
